@if (!settings?.disabledMessage?.length) {
  <span>This site is currently not available.</span>
}
@if (settings?.disabledMessage?.length) {
  <span>{{ settings?.disabledMessage }}</span>
}
<img src="/assets/theFoodChecker-logo-col1-withStrap.svg" />
